import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useDidMount } from 'rooks';
import { logout } from '../redux/actions';

const LogoutRoute = () => {
	const dispatch = useDispatch();
	const token = useSelector((state) => state.user?.token);
	useDidMount(() => {
		dispatch(logout());
	});
	return !token ? <Redirect to="/login" /> : null;
};

export default LogoutRoute;
